import { render, staticRenderFns } from "./BindCatalogsView.vue?vue&type=template&id=55c83630"
import script from "./BindCatalogsView.vue?vue&type=script&lang=js"
export * from "./BindCatalogsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports